<!-- <ngx-loading-bar color="#0272b6" height="3px" [includeSpinner]="false"></ngx-loading-bar> -->
<ui-view></ui-view>
